//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { ToastNotificationsActionType } from '@legacy-components/common/toast-notifications/toastNotificationsActions';
import { TOAST_NOTIFICATIONS_ACTIONS } from '@legacy-components/common/toast-notifications/toastNotificationsConstants';
import {
  IToastNotificationWithId,
  IToastNotifications,
} from '@legacy-components/common/toast-notifications/toastNotificationsModel';
import uuid from '@utils/uuid';


const initialState: IToastNotifications = {
  toastNotifications: [],
  toastNotificationsToClose: [],
};

export default function ToastNotificationsReducer(
  state: IToastNotifications = initialState,
  action: ToastNotificationsActionType,
) {
  switch (action.type) {
    case TOAST_NOTIFICATIONS_ACTIONS.ADD_TOAST_NOTIFICATION: {
      const toastNotificationWithId: IToastNotificationWithId = {
        id: uuid(),
        ...action.toastNotification,
      };

      return {
        ...state,
        toastNotifications: [
          ...state.toastNotifications,
          toastNotificationWithId,
        ],
      };
    }
    case TOAST_NOTIFICATIONS_ACTIONS.REMOVE_TOAST_NOTIFICATION: {
      const filteredToastNotifications = state.toastNotifications.filter(
        (notification) => {
          return notification.id !== action.toastNotificationId;
        },
      );

      return {
        ...state,
        toastNotifications: filteredToastNotifications,
      };
    }
    case TOAST_NOTIFICATIONS_ACTIONS.CLOSE_TOAST_NOTIFICATION: {
      const toastNotificationsToClose = [
        ...state.toastNotificationsToClose,
        action.toastNotificationId,
      ];
      return {
        ...state,
        toastNotificationsToClose,
      };
    }
    case TOAST_NOTIFICATIONS_ACTIONS.REMOVE_CLOSED_TOAST_NOTIFICATION: {
      const filteredToastNotifications = state.toastNotificationsToClose.filter(
        (toastNotificationId) => {
          return toastNotificationId !== action.toastNotificationId;
        },
      );

      return {
        ...state,
        toastNotificationsToClose: filteredToastNotifications,
      };
    }
    default:
      return state;
  }
}
